// AP · Auto-add quà theo mốc (engine Cart Offers, 2026-08-17 — generalize từ bản 1 quà cứng).
// Load qua snippets/ap-cart-gift.liquid: <script defer data-tiers='[{variant,threshold,tag}]'>.
// Ngưỡng = cart.total_price (sau discount) − tổng line quà. Đạt mốc → /cart/add.js variant quà
// (properties _gift=tag, _slot=cart-gift); tụt mốc → /cart/change.js remove. Trigger:
// shopify:cart:lines-update (Horizon fire cho mọi mutation) + sync khi load. Chống vòng lặp: debounce
// + busy flag; sau mutation của chính mình bắn event refresh để Horizon re-render section.
(function () {
  'use strict';
  if (window.__apCartGift) return;
  window.__apCartGift = true;
  var el = document.currentScript;
  var tiers = [];
  try { tiers = JSON.parse(el && el.dataset.tiers || '[]'); } catch (_) { tiers = []; }
  tiers = tiers.filter(function (t) { return t && Number(t.variant) && Number(t.threshold) > 0; });
  // 2026-08-17: chế độ dọn (data-cleanup="1", tiers rỗng) — không thêm quà, chỉ gỡ line quà còn
  // sót trong giỏ cũ. Vòng dọn cuối sync() đã xử đúng việc này khi tag không còn mốc nào khớp.
  var cleanup = !!(el && el.dataset.cleanup);
  if (!tiers.length && !cleanup) return;
  // dirty = giỏ vừa đổi nhưng chưa sync xong. Dùng để chặn checkout đi trước khi quà kịp vào giỏ
  // (2026-08-19: 4/5 đơn ăn mốc $250 mà KHÔNG có quà — nút checkout điều hướng thẳng /checkout
  //  trong khi sync còn đang chờ debounce 700ms + 2 round-trip).
  var busy = false, timer = null, dirty = false, pending = null;
  function schedule() { dirty = true; clearTimeout(timer); timer = setTimeout(sync, 700); }
  function syncNow() { clearTimeout(timer); return (busy && pending) ? pending.then(sync) : sync(); }
  function notify() {
    var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    ev.promise = Promise.resolve({ detail: {} });
    document.dispatchEvent(ev);
  }
  function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }); }
  function sync() {
    if (busy) return pending || Promise.resolve();
    busy = true;
    pending = fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      var giftLines = items.filter(function (i) { return i.properties && i.properties._gift; });
      var giftTotal = giftLines.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      // 2026-10-04 (owner, #AFP23329): sale twins do not count toward the gift tiers (same rule as free shipping,
      // ap-freeship-bar hides the tiers for them). Twin handles end in "-promo" (a few duplicates "-promo-1").
      var promoTotal = items.reduce(function (s, i) { return s + (!(i.properties && i.properties._gift) && /-promo(-\d+)?$/.test(i.handle || '') ? i.final_line_price : 0); }, 0);
      var totalEx = cart.total_price - giftTotal - promoTotal;
      var ops = [];
      // AFP-AB cart-ladder-1 (2026-10-19): arm b (<html data-afp-ab-cart-ladder-1="b">) runs the gift ladder instead
      // (assets/ap-cart-ladder.js), so it has no scarf tier: nothing is added and the cleanup below removes a scarf line
      // added before the arm arrived. Everyone else (arm a, not in test, runtime off) gets active === tiers, as before.
      // 19/10 18:30: ladder mode "all" (window.__apclAll, set by snippets/ap-cart-ladder.liquid) = no scarf tier for anyone.
      var active = (window.__apclAll === true || document.documentElement.getAttribute('data-afp-ab-cart-ladder-1') === 'b') ? [] : tiers;
      active.forEach(function (t) {
        var have = giftLines.find(function (i) { return i.properties._gift === t.tag; });
        // 2026-08-19: quà đổi từ khăn $41.99 sang biến thể quà giá $0 → giỏ cũ vẫn còn line
        // variant cũ với ĐÚNG tag này. Nếu chỉ so tag thì coi như "đã có quà", không thay, và
        // khách bị tính đủ $41.99 (discount bù tiền đã tắt). Variant lệch thì gỡ ngay; lần sync
        // kế tiếp (notify) sẽ thêm lại đúng biến thể $0.
        if (have && Number(have.variant_id) !== Number(t.variant)) {
          ops.push(post('/cart/change.js', { id: have.key, quantity: 0 }));
          return;
        }
        if (totalEx >= t.threshold && !have) {
          ops.push(post('/cart/add.js', { id: Number(t.variant), quantity: 1, properties: { _slot: 'cart-gift', _gift: t.tag } }));
        } else if (totalEx < t.threshold && have) {
          ops.push(post('/cart/change.js', { id: have.key, quantity: 0 }));
        }
      });
      // dọn quà của mốc đã bị tắt/đổi (tag không còn trong config)
      giftLines.forEach(function (i) {
        var tag = i.properties._gift;
        if ((/^gift-t\d+-/.test(tag) || tag === 'silk-scarf-250') && !active.some(function (t) { return t.tag === tag; })) ops.push(post('/cart/change.js', { id: i.key, quantity: 0 }));
      });
      if (!ops.length) return null;
      return Promise.all(ops).then(function () { notify(); });
    }).catch(function () {}).then(function () { busy = false; dirty = false; pending = null; });
    return pending;
  }
  // 2026-08-17 (QA): Horizon dispatch lines-update TRƯỚC khi fetch add xong → chờ event.promise rồi mới sync
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var p = e && e.promise;
    if (p && typeof p.then === 'function') p.then(schedule, schedule); else schedule();
  });
  // re-sync khi drawer mở (phòng miss) + khi tab quay lại
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.header-actions__cart-icon, a[href="/cart"], .cart-icon, cart-icon') : null;
    if (t) schedule();
  }, true);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  // Chặn checkout đi trước khi quà kịp vào giỏ. Bắt ở capture phase để chạy TRƯỚC onclick inline
  // của nút (nút điều hướng thẳng /checkout). Chốt 1.5s để mạng chậm cũng không kẹt khách lại.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#checkout, [name="checkout"], .cart__checkout-button') : null;
    if (!btn || btn.disabled) return;
    if (!dirty && !busy) return; // đã đồng bộ — để theme xử lý như bình thường
    e.preventDefault();
    e.stopImmediatePropagation();
    var went = false;
    function go() { if (went) return; went = true; window.location.href = '/checkout'; }
    setTimeout(go, 1500);
    syncNow().then(go, go);
  }, true);
  schedule();
})();
